import CommentIcon from "@mui/icons-material/Comment";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import PostAddOutlinedIcon from "@mui/icons-material/PostAddOutlined";
import QueueOutlinedIcon from "@mui/icons-material/QueueOutlined";
import VisibilityOutlinedIcons from "@mui/icons-material/VisibilityOutlined";
import { Checkbox, Divider, Grid2, IconButton } from "@mui/material";
import Button from "@mui/material/Button";
import TableBody from "@mui/material/TableBody";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import makeStyles from "@mui/styles/makeStyles";
import classNames from "classnames";
import { getSorting, stableSort } from "components/advertising/AdvTable";
import AtsTooltip from "components/common/AtsTooltip";
import { Paths } from "components/common/navigation";
import { createDeepEqualSelector } from "components/common/utils";
import { actions as reportAdvActions } from "components/report/advertising/logic/advReportActions";
import { actions as reportLogActions } from "components/report/logsheet/logic/logReportActions";
import { ATTRIBUTE_TYPES, formatAssetLengthInteger } from "core/dataConstants";
import { assertArray, assertString } from "core/validation";
import { get } from "lodash";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { connect, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { useStyles } from "../AdvTable/tableStyles";
import { actions } from "../logic/formActions";
import {
    DATE_FORMAT_ONLY_YEAR,
    formatDate,
    DATE_FORMAT_HOUR_AM_PM,
    DATE_FORMAT_SHORT_YEAR
} from "components/common/dateUtils";
import { isReadOnlyRole } from "../../login/logic/sagas";
import { currentUserSelector } from "../../login/logic/actions";

const tableStyles = makeStyles(useStyles);
function getLength(adv) {
    if (adv.attributes && adv.attributes.length > 0) {
        const lenAtr = adv.attributes.find((at) => at.attributeType === ATTRIBUTE_TYPES.ASSET_LENGTH);
        if (lenAtr && lenAtr.attributeValue && !isNaN(lenAtr.attributeValue)) {
            return formatAssetLengthInteger(parseInt(lenAtr.attributeValue));
        }
    }
    return null;
}

function isCutFinal(adv) {
    if (adv.attributes && adv.attributes.length > 0) {
        const lenAtr = adv.attributes.find((at) => at.attributeType === ATTRIBUTE_TYPES.ASSET_CUT);
        return lenAtr && lenAtr.attributeValue;
    }
    return false;
}

const AdvTableBody = (props) => {
    const {
        list,
        customList,
        addToLogReport,
        showFilm,
        showCompany,
        expandAllRows,
        expandFromAllButton,
        onChangeExpanded,
        toggleAdvertisingForm,
        refresh,
        addToReport,
        onToggleSelection,

        reducedView,
    } = props;

    const classes = tableStyles();

    return (
        <TableBody className={"stripe-table "}>
            { }
            {(customList || list).map((advId) => {
                return (
                    <ConnectedAdvItem
                        customAdv={customList && advId}
                        reducedView={reducedView}
                        showFilm={showFilm}
                        showCompany={showCompany}
                        key={advId}
                        id={advId}
                        classes={classes}
                        onToggleSelection={onToggleSelection}
                        addToReport={addToReport}
                        addToLogReport={addToLogReport}
                        expandAllRows={expandAllRows}
                        expandFromAllButton={expandFromAllButton}
                        onChangeExpanded={onChangeExpanded}
                        toggleAdvertisingForm={toggleAdvertisingForm}
                        refresh={refresh}
                    />
                );
            })}
            { }
        </TableBody>
    );
};

AdvTableBody.propTypes = {
    list: PropTypes.any,
    addToLogReport: PropTypes.any,
    showFilm: PropTypes.any,
    showCompany: PropTypes.any,
    expandAllRows: PropTypes.any,
    expandFromAllButton: PropTypes.any,
    onChangeExpanded: PropTypes.any,
    toggleAdvertisingForm: PropTypes.any,
    refresh: PropTypes.any,
    addToReport: PropTypes.any,
    onToggleSelection: PropTypes.any,
};

const getId = (state, props) => props.id;
const getAdv = () => {
    return createDeepEqualSelector(
        [
            getId,
            (state) => get(state.advertising, "list", []),
            (state) => get(state.advertising, "selectedAdv", []),
            (state) => state.advertising.globalSelectionMode,
        ],
        (id, list, selectedAdv) => {
            const adv = list.find((s) => s.id === id);
            return {
                adv,
                selected: selectedAdv.findIndex((ad) => ad.id === id) !== -1,
            };
        }
    );
};

const makeMapStateToProps = () => {
    const getAdvReducer = getAdv();
    return (state, props) => {
        return { ...getAdvReducer(state, props) };
    };
};

const ConnectedAdvItem = connect(makeMapStateToProps)(AdvITableItem);
export function AdvITableItem({
    adv,
    customAdv,
    defaultExpanded,
    showFilm,
    showCompany,
    expandAllRows,
    expandFromAllButton,
    onChangeExpanded,
    toggleAdvertisingForm,
    selected,
    id,
    classes: propClasses,
    onToggleSelection,
    onRemoveFromReport,
    showCompactForReport,
    reducedView,
    addToReport,
    addToLogReport,
}) {
    const advItem = customAdv || adv;
    const [expanded, setExpanded] = useState(defaultExpanded);

    const classes = propClasses || tableStyles();

    useEffect(() => {
        if (expandFromAllButton) {
            setExpanded(expandAllRows);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [expandAllRows]);

    function onClickExpand() {
        if (expanded) {
            onChangeExpanded([!expanded, false]);
        }
        setExpanded(!expanded);
    }

    const status = get(advItem.review, "reviewStatusType.name", "");
    const lengValue = getLength(advItem);
    const isFinal = isCutFinal(advItem);

    const privateNotes = advItem.review && assertString(advItem.review.privateNote) ? advItem.review.privateNote : null;
    const viewers = advItem.review?.viewers?.length > 0 ? advItem.review.viewers : null;

    const filmTitle = get(advItem, "filmRelease.title", "");
    const companyName = get(advItem, "filmRelease.companyId.title", "");

    const filmReleaseDate = get(advItem, "filmRelease.releaseDate", null);
    const filmEntered = get(advItem, "filmRelease.enteredDate", filmReleaseDate);
    const filmRating = get(advItem, "filmRelease.filmRatingTypeId.abbreviation", "");
    const filmRelease = get(advItem, "filmRelease.filmReleaseTypeId.abbreviation", "");
    const exception = advItem.exception;
    const user = useSelector(currentUserSelector);

    function handleOnReport(e) {
        e.stopPropagation();
        addToReport([advItem]);
    }
    function handleOnLogReport(e) {
        e.stopPropagation();
        addToLogReport([advItem]);
    }
    function handleToggleSelection(e) {
        e.stopPropagation();
        onToggleSelection(advItem);
    }
    function handleExpandedOnclick(e) {
        e.stopPropagation();
    }
    function handleRemoveFromReport(e) {
        e.stopPropagation();
        onRemoveFromReport(advItem);
    }

    function handleEdit(e) {
        if (e) {
            e.stopPropagation();
        }
        toggleAdvertisingForm(true, id);
    }

    const rowStyle = showCompactForReport
        ? {
            borderLeft: 0,
            margin: -1,
        }
        : {};
    return (
        (<Grid2
            container
            spacing={1}
            style={rowStyle}
            className={classNames(
                classes.tableRow,
                " stripe-row",
                exception ? classes.exceptionAdv : "",
                selected ? classes.selectedRow : ""
            )}
            onClick={onClickExpand}
            component={"tr"}
        >
            { }
            { }
            { }
            { }
            { }
            { }
            { }
            {(showCompany || showFilm) && (
                <Grid2 component={"td"} minWidth={0} size={12}>
                    <Typography className={"atsFloatLeft"} style={{ fontWeight: 600, marginLeft: 10 }} noWrap>
                        {showFilm && filmTitle}
                    </Typography>
                    <Typography noWrap className={" atsFloatLeft textOpacity6"} style={{ marginLeft: 20 }}>
                        {showFilm && filmRating}
                    </Typography>
                    <Typography noWrap className={" atsFloatLeft textOpacity6"} style={{ marginLeft: 10 }}>
                        {showFilm && filmRelease}
                    </Typography>
                    <Typography noWrap className={" atsFloatLeft textOpacity6"} style={{ marginLeft: 20 }}>
                        {showCompany && companyName}
                    </Typography>
                    <Typography noWrap className={" atsFloatLeft textOpacity6"} style={{ marginLeft: 20 }}>
                        {showFilm && (filmEntered ? formatDate(filmEntered, DATE_FORMAT_ONLY_YEAR) : null)}
                    </Typography>
                </Grid2>
            )}
            <Grid2
                component={"td"}
                minWidth={0}
                size={{
                    xl: 4,
                    lg: 6,
                    md: 6,
                    xs: 12,
                    sm: 7
                }}>
                <div className={classes.dateContainer}>
                    {!reducedView && (
                        <>
                            {showCompactForReport ? (
                                <span className={"atsFloatLeft"} style={{ width: 20 }}>
                                    <Tooltip title="Remove from Report List ">
                                        <IconButton
                                            style={{ padding: 3 }}
                                            size="small"
                                            onClick={handleRemoveFromReport}
                                        >
                                            <DeleteOutlineOutlinedIcon />
                                        </IconButton>
                                    </Tooltip>
                                </span>
                            ) : (
                                !isReadOnlyRole(user) && <span className={"atsFloatLeft"} style={{ width: 20 }}>
                                    <Tooltip title="Select ">
                                        <Checkbox
                                            checked={selected}
                                            disableRipple
                                            style={{ padding: 0 }}
                                            color={"secondary"}
                                            onClick={handleToggleSelection}
                                        />
                                    </Tooltip>
                                </span>
                            )}
                        </>
                    )}
                    <span className={"atsFloatLeft"} style={{ textAlign: "center", marginLeft: 8 }}>
                        <Typography>{formatDate(advItem.dateEntered, DATE_FORMAT_SHORT_YEAR)}</Typography>
                        <div className={classes.subRow}>
                            <Typography> {formatDate(advItem.dateEntered, DATE_FORMAT_HOUR_AM_PM)}</Typography>
                            { }
                        </div>
                        {!reducedView && !isReadOnlyRole(user) && (
                            <div className={classes.subRow}>
                                <Button size={"small"} variant={"outlined"} onClick={handleEdit}>
                                    Edit
                                </Button>
                            </div>
                        )}
                    </span>
                </div>
                <div className={classes.dataContainer}>
                    <AtsTooltip
                        trigger={
                            <div className={classes.subRow + " " + classes.advNameContainer}>
                                <Typography style={{ width: "99%" }} className={"block-ellipsis-3-lines"}>
                                    {advItem.name}
                                </Typography>
                            </div>
                        }
                        content={<Typography style={{ width: "99%" }}> {advItem.name}</Typography>}
                    />
                    <div className={classes.advTypeContent}>
                        <span className={classes.advTypeName}>
                            <Typography className={"subtext"}>
                                {advItem.quantity && parseInt(advItem.quantity) > 1 ? ` ${advItem.quantity} ` : ""}
                                {advItem.advertisementType.name}
                                {isFinal ? " (Final)" : ""}
                            </Typography>
                        </span>
                        <span className={classes.finalInfo}>
                            {lengValue && (
                                <Typography className={"subtext " + classes.lenText}>{lengValue} sec</Typography>
                            )}
                        </span>
                    </div>
                    {!showCompactForReport ? (
                        <div className={classes.advTypeContent}>
                            <Link style={{ textDecoration: "none" }} to={`${Paths.ADVERTISING}/${advItem.id}`}>
                                <Tooltip title="View ">
                                    <IconButton style={{ padding: 3 }} size="small">
                                        <VisibilityOutlinedIcons />
                                    </IconButton>
                                </Tooltip>
                            </Link>
                            {!reducedView && !isReadOnlyRole(user) && (
                                <Tooltip title="Add to Report">
                                    <IconButton style={{ padding: 3 }} size="small" onClick={handleOnReport}>
                                        <PostAddOutlinedIcon />
                                    </IconButton>
                                </Tooltip>
                            )}
                            {!isReadOnlyRole(user) && <Tooltip title="Add to Logs">
                                <IconButton style={{ padding: 3 }} size="small" onClick={handleOnLogReport}>
                                    <QueueOutlinedIcon />
                                </IconButton>
                            </Tooltip>}
                        </div>
                    ) : (
                        <Link style={{ textDecoration: "none" }} to={`${Paths.ADVERTISING}/${advItem.id}`}>
                            <Tooltip title="View ">
                                <IconButton style={{ padding: 3 }} size="small">
                                    <VisibilityOutlinedIcons />
                                </IconButton>
                            </Tooltip>
                        </Link>
                    )}
                </div>
            </Grid2>
            <Grid2
                component={"td"}
                container
                size={{
                    xl: 8,
                    lg: 6,
                    md: 6,
                    sm: 5,
                    xs: 12
                }}>
                <Grid2 sx={{ display: { md: "none", lg: "block", xl: "block", sm: "none", xs: "none" } }}
                    size={{
                        xl: 6,
                        lg: 6,
                        md: 12
                    }}>
                    <AtsTooltip
                        trigger={
                            <div>
                                <div className={classes.advStatus}>
                                    <Typography className={"subtext  wrapText"}>{status}</Typography>
                                </div>
                                <Typography
                                    style={{ fontSize: "0.9rem" }}
                                    className={"block-ellipsis-3-lines no-padding-html-text"}
                                    dangerouslySetInnerHTML={{
                                        __html: advItem.review ? advItem.review.instruction : "No Review",
                                    }}
                                />
                            </div>
                        }
                        content={
                            <React.Fragment>
                                <Typography style={{ paddingBottom: 5 }} className={"wrapText bold600"}>
                                    {status}
                                </Typography>

                                <Typography className={"bold600"}>Instructions: </Typography>
                                <Typography
                                    className={"no-padding-html-text"}
                                    dangerouslySetInnerHTML={{
                                        __html: advItem.review ? advItem.review.instruction : "No Review",
                                    }}
                                />
                            </React.Fragment>
                        }
                        contentStyle={{ maxWidth: 600, maxHeight: 400, overflow: "scroll" }}
                    />
                </Grid2>
                {(privateNotes || viewers) && (
                    <Grid2 sx={{ display: { md: "block", lg: "block", xl: "block", sm: "block", xs: "none" } }}
                        size={{
                            xl: 6,
                            lg: 6,
                            md: 12,
                            xs: 12
                        }}>
                        <span className={classes.privateNoteIcon}>
                            <CommentIcon />
                        </span>
                        <AtsTooltip
                            trigger={
                                <Typography
                                    style={{ fontSize: "0.9rem" }}
                                    className={"block-ellipsis-4-lines no-padding-html-text"}
                                    dangerouslySetInnerHTML={{ __html: privateNotes ? privateNotes : viewers ? viewers.map(viewer => viewer.name).join(", ") : "" }}
                                />
                            }
                            content={
                                <React.Fragment>
                                    {privateNotes && <Typography className={"bold600"}>Private Notes: </Typography>}
                                    <Typography
                                        className={"no-padding-html-text"}
                                        dangerouslySetInnerHTML={{ __html: privateNotes ? privateNotes : "" }}
                                    />
                                    {viewers && <Typography className={"bold600"} display={"flex"}>
                                        Viewers:
                                        <Typography
                                            paddingLeft={1}
                                            className={"no-padding-html-text"}
                                            dangerouslySetInnerHTML={{ __html: viewers ? viewers.map(viewer => viewer.name).join(", ") : "" }}/>
                                    </Typography>}

                                </React.Fragment>
                            }
                            contentStyle={{ maxWidth: 600, maxHeight: 400, overflow: "scroll" }}
                        />
                    </Grid2>
                )}
            </Grid2>
            { }
            { }
            { }
            { }
            { }
            { }
            { }
            {expanded && (
                <Grid2 component={"td"} onClick={handleExpandedOnclick} size={12}>
                    <Grid2 size={12}>
                        <Divider style={{ margin: 9 }} />
                    </Grid2>
                    <Grid2 container spacing={2}>
                        <Grid2
                            size={{
                                xs: 2,
                                xl: 1
                            }}></Grid2>
                        <Grid2
                            size={{
                                xs: 10,
                                xl: 11
                            }}>
                            <Typography className={"bold600"}>Instructions: </Typography>
                            <Typography
                                className={"no-padding-html-text"}
                                dangerouslySetInnerHTML={{
                                    __html: advItem.review ? advItem.review.instruction : "No Review",
                                }}
                            />
                        </Grid2>
                        {privateNotes && <Grid2
                            size={{
                                xs: 2,
                                xl: 1
                            }}></Grid2>}
                        {privateNotes && (
                            <Grid2
                                size={{
                                    xs: 10,
                                    xl: 11
                                }}>
                                <Typography className={"bold600"}>Private Notes: </Typography>
                                <Typography
                                    className={"no-padding-html-text"}
                                    dangerouslySetInnerHTML={{ __html: privateNotes ? privateNotes : "" }}
                                />
                            </Grid2>
                        )}
                        {viewers && <Grid2
                            size={{
                                xs: 2,
                                xl: 1
                            }}></Grid2>}
                        {viewers && (
                            <Grid2
                                size={{
                                    xs: 10,
                                    xl: 11
                                }}>
                                <Typography className={"bold600"} style={{paddingRight:3}}>Viewers:</Typography>
                                <Typography
                                    className={"no-padding-html-text"}
                                    dangerouslySetInnerHTML={{ __html: viewers ? viewers.map(viewer => viewer.name).join(", ") : "" }}
                                />
                            </Grid2>
                        )}
                    </Grid2>
                </Grid2>
            )}
        </Grid2>)
    );
}

AdvITableItem.propTypes = {
    adv: PropTypes.any,
    defaultExpanded: PropTypes.any,
    showFilm: PropTypes.any,
    showCompany: PropTypes.any,
    expandAllRows: PropTypes.any,
    expandFromAllButton: PropTypes.any,
    onChangeExpanded: PropTypes.any,
    toggleAdvertisingForm: PropTypes.any,
    selected: PropTypes.any,
    id: PropTypes.any,
    classes: PropTypes.any,
    propClasses: PropTypes.any,
    onToggleSelection: PropTypes.any,
    onRemoveFromReport: PropTypes.any,
    showCompactForReport: PropTypes.any,
    addToReport: PropTypes.any,
    addToLogReport: PropTypes.any,
};
const mapDispatchToProps = (dispatch) => ({
    toggleAdvertisingForm: (editing, id) => dispatch(actions.TOGGLE_ADVERTISING_FORM.send({ editing, id })),
    refresh: () => dispatch(actions.REFRESH_TABLE.send()),
    addToReport: (adv) => dispatch(reportAdvActions.ON_ADD_ADV_TO_REPORT.send(adv)),
    addToLogReport: (adv) => dispatch(reportLogActions.ON_ADD_ADV_TO_LOG_REPORT.send(adv)),
    onToggleSelection: (adv) => dispatch(actions.TOGGLE_SELECTION.call(adv)),
});

const tableSelector = createDeepEqualSelector(
    (advertising) => advertising.list,
    (advertising) => advertising.form.orderBy,
    (advertising) => advertising.form.order,
    (list, orderBy, order) => {
        const listSorted = stableSort(list, getSorting(order, orderBy));
        return {
            list: assertArray(listSorted) ? listSorted.map((l) => l.id) : [],
        };
    }
);

export default connect((state) => {
    return tableSelector(state.advertising);
}, mapDispatchToProps)(AdvTableBody);
